<template>
	<div class="p-styleguide">

		<!-- example -->
	    <div class="st-group">
	        <div class="container container-max">
	            <h2 class="st-headline st-headline--2">Sales Tool</h2>
	            <div class="dive"></div>
	            <h3 class="st-headline st-headline--3">Example Type</h3>
	            <div class="row"><div class="col-xs-12"></div></div>
	        </div>
	    </div>
	    <!-- /example -->



	    <!-- Headlines -->
	    <div class="st-group">
	        <div class="container container-max">
	            <h2 class="st-headline st-headline--2">Headlines</h2>
	            <div class="dive"></div>
	            <h3 class="st-headline st-headline--1">Headline 1</h3>
	            <div class="dive"></div>
	            <h3 class="st-headline st-headline--2">Headline 2</h3>
	            <div class="dive"></div>
	            <h3 class="st-headline st-headline--3">Headline 3</h3>
	        </div>
	    </div>
	    <!-- /Headlines -->

	    <!-- text -->
	    <div class="st-group">
	        <div class="container container-max">
	            <h2 class="st-headline st-headline--2">Text</h2>
	            <div class="dive"></div>
	            <div class="row">
	                <div class="col-xs-12">
	                    <div class="user-content-wrapper">
	                        <p>Lorem <b>ipsum</b> <i>dolor</i> <b><i>sit amet</i></b>, consectetur adipisicing elit. Dolore at tempore odio unde sapiente maxime sunt, omnis amet neque mollitia eius velit in, culpa ipsum ipsa tenetur perferendis atque. <a href="#">Esse</a>.</p>
	                        <p>Nesciunt dolores dignissimos corporis soluta ex distinctio velit labore recusandae nemo quia obcaecati numquam optio, quo officiis, suscipit laboriosam dolore quae consequuntur fuga odit dolor. Voluptatibus eaque, dolore consectetur in!</p>
	                    </div>
	                </div>
	            </div>
	        </div>
	    </div>
	    <!-- /text -->


	    <!-- button -->
	    <div class="st-group">
	        <div class="container container-max">
	            <h2 class="st-headline st-headline--2">Buttons</h2>
	            <div class="dive"></div>
	            <h3 class="st-headline st-headline--3">Normal</h3>
	            <div class="row">
	                <div class="col-xs-12 col-sm-3">
	                    <a href="#" class="st-btn st-btn--small">Small</a><br>
	                    <a href="#" class="st-btn">Button</a><br>
	                    <a href="#" class="st-btn st-btn--hover">Hover</a><br>
	                    <a href="#" class="st-btn st-btn--active">Active</a><br>
	                    <a href="#" class="st-btn st-btn--disabled">disabled</a><br>
	                    <a href="#" class="st-btn st-btn--loading">Loading</a>
	                </div>
	                <div class="col-xs-12 col-sm-3">
	                    <input type="button" value="Small" class="st-btn st-btn--small"><br>
	                    <input type="button" value="Button" class="st-btn"><br>
	                    <input type="button" value="Hover" class="st-btn st-btn--hover"><br>
	                    <input type="button" value="Active" class="st-btn st-btn--active"><br>
	                    <input type="button" value="disabled" class="st-btn st-btn--disabled"><br>
	                    <input type="button" value="Loading" class="st-btn st-btn--loading">
	                </div>
	                <div class="col-xs-12 col-sm-3">
	                    <button class="st-btn st-btn--small">Small</button><br>
	                    <button class="st-btn">Button</button><br>
	                    <button class="st-btn st-btn--hover">Hover</button><br>
	                    <button class="st-btn st-btn--active">Active</button><br>
	                    <button class="st-btn st-btn--disabled ">disabled</button><br>
	                    <button class="st-btn st-btn--loading">Loading</button>
	                </div>
	            </div>
	            <div class="dive"></div>
	            <h3 class="st-headline st-headline--3">Primary / Aktion</h3>
	            <div class="row">
	                <div class="col-xs-12 col-sm-3">
	                    <a href="#" class="st-btn st-btn--small st-btn--primary">Small</a><br>
	                    <a href="#" class="st-btn st-btn--primary">Button</a><br>
	                    <a href="#" class="st-btn st-btn--hover st-btn--primary">Hover</a><br>
	                    <a href="#" class="st-btn st-btn--active st-btn--primary">Active</a><br>
	                    <a href="#" class="st-btn st-btn--disabled st-btn--primary">Disabled</a><br>
	                    <a href="#" class="st-btn st-btn--loading st-btn--primary">Loading</a><br>
	                    <a href="#" class="st-btn st-btn--disabled st-btn--loading st-btn--primary">Disabled Loading</a>
	                </div>
	                <div class="col-xs-12 col-sm-3">
	                    <input type="button" value="Small" class="st-btn st-btn--small st-btn--primary"><br>
	                    <input type="button" value="Button" class="st-btn st-btn--primary"><br>
	                    <input type="button" value="Hover" class="st-btn st-btn--hover st-btn--primary"><br>
	                    <input type="button" value="Active" class="st-btn st-btn--active st-btn--primary"><br>
	                    <input type="button" value="disabled" disabled class="st-btn st-btn--disabled st-btn--primary"><br>
	                    <input type="button" value="Loading" class="st-btn st-btn--loading st-btn--primary"><br>
	                    <input type="button" value="Disabled Loading" class="st-btn st-btn--disabled st-btn--loading st-btn--primary">
	                </div>
	                <div class="col-xs-12 col-sm-3">
	                    <button class="st-btn st-btn--small st-btn--primary">Small</button><br>
	                    <button class="st-btn st-btn--primary">Button</button><br>
	                    <button class="st-btn st-btn--hover st-btn--primary">Hover</button><br>
	                    <button class="st-btn st-btn--active st-btn--primary">Active</button><br>
	                    <button class="st-btn st-btn--disabled st-btn--primary">Disabled</button><br>
	                    <button class="st-btn st-btn--loading st-btn--primary">Loading</button><br>
	                    <button class="st-btn st-btn--disabled st-btn--loading st-btn--primary">Disabled Loading</button>
	                </div>
	            </div>
	            <div class="dive"></div>
	            <h3 class="st-headline st-headline--3">Dark</h3>
	            <div class="row">
	                <div class="col-xs-12 col-sm-3">
	                    <a href="#" class="st-btn st-btn--small st-btn--dark">Small</a><br>
	                    <a href="#" class="st-btn st-btn--dark">Button</a><br>
	                    <a href="#" class="st-btn st-btn--hover st-btn--dark">Hover</a><br>
	                    <a href="#" class="st-btn st-btn--active st-btn--dark">Active</a><br>
	                    <a href="#" class="st-btn st-btn--disabled st-btn--dark">Disabled</a><br>
	                    <a href="#" class="st-btn st-btn--loading st-btn--dark">Loading</a><br>
	                    <a href="#" class="st-btn st-btn--disabled st-btn--loading st-btn--dark">Disabled Loading</a>
	                </div>
	                <div class="col-xs-12 col-sm-3">
	                    <input type="button" value="Small" class="st-btn st-btn--small st-btn--dark"><br>
	                    <input type="button" value="Button" class="st-btn st-btn--dark"><br>
	                    <input type="button" value="Hover" class="st-btn st-btn--hover st-btn--dark"><br>
	                    <input type="button" value="Active" class="st-btn st-btn--active st-btn--dark"><br>
	                    <input type="button" value="disabled" disabled class="st-btn st-btn--disabled st-btn--dark"><br>
	                    <input type="button" value="Loading" class="st-btn st-btn--loading st-btn--dark"><br>
	                    <input type="button" value="Disabled Loading" class="st-btn st-btn--disabled st-btn--loading st-btn--dark">
	                </div>
	                <div class="col-xs-12 col-sm-3">
	                    <button class="st-btn st-btn--small st-btn--dark">Small</button><br>
	                    <button class="st-btn st-btn--dark">Button</button><br>
	                    <button class="st-btn st-btn--hover st-btn--dark">Hover</button><br>
	                    <button class="st-btn st-btn--active st-btn--dark">Active</button><br>
	                    <button class="st-btn st-btn--disabled st-btn--dark">Disabled</button><br>
	                    <button class="st-btn st-btn--loading st-btn--dark">Loading</button><br>
	                    <button class="st-btn st-btn--disabled st-btn--loading st-btn--dark">Disabled Loading</button>
	                </div>
	            </div>
	        </div>
	    </div>
	    <!-- /button -->

		<!-- loading -->
	    <div class="st-group">
	        <div class="container container-max">
	            <h2 class="st-headline st-headline--2">Loading</h2>
	            <div class="dive"></div>
	            <div class="row">
	            	<div class="col-xs-12">

	            	</div>
	           	</div>
	        </div>
	    </div>
	    <!-- /loading -->



	    <!-- inputs -->
	    <div class="st-group">
	        <div class="container container-max">
	            <h2 class="st-headline st-headline--2">Inputs</h2>
	            <div class="dive"></div>
	            <div class="row col-xs-12 col-sm-6">
	                <h3 class="st-headline st-headline--3">Text</h3>
	                <input type="text" class="st-input st-input--text" placeholder="Name"><br>
	                <input type="text" class="st-input st-input--text" placeholder="Name" value="Pascal Franzke"><br>
	                <input type="text" class="st-input st-input--error st-input--text" placeholder="Name" value="Pascal Franzke"><br>
	                <input disabled type="text" class="st-input st-input--disabled st-input--text" placeholder="Name" value="Pascal Franzke"><br />
	            </div>
	            <div class="dive"></div>
	            <div class="row col-xs-12 col-sm-6">
	                <h3 class="st-headline st-headline--3">Textarea</h3>

	                <textarea class="st-input st-input--textarea" name="" id="" cols="50" rows="4" placeholder="example textarea"></textarea><br>
	                <textarea class="st-input st-input--textarea" name="" id="" cols="50" rows="4" placeholder="example textarea">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dicta corporis voluptatem possimus voluptate harum ducimus aliquid tempora. Dolorum omnis impedit a, ex totam et minus, dicta quisquam soluta iusto hic.</textarea><br>
	                <textarea class="st-input st-input--error st-input--textarea" name="" id="" cols="50" rows="4" placeholder="example textarea">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem sint quod sequi fugiat, modi ratione aliquid. In sint tenetur nostrum cupiditate harum, repudiandae sapiente provident veritatis ducimus quisquam rerum, quos.</textarea><br>
	                <textarea disabled class="st-input st-input--disabled st-input--textarea" name="" id="" cols="50" rows="4" placeholder="example textarea">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatem sint quod sequi fugiat, modi ratione aliquid. In sint tenetur nostrum cupiditate harum, repudiandae sapiente provident veritatis ducimus quisquam rerum, quos.</textarea>
	            </div>
	        </div>
	    </div>
	    <!-- /inputs -->

	    <!-- checkbox -->
	    <div class="st-group">
	        <div class="container container-max">

	            <div class="dive"></div>
	            <div class="row col-xs-12 col-sm-6">
	                <h2 class="st-headline st-headline--2">Checkbox</h2>
	                <div>
	                    <div class="st-checkbox">
	                        <input class="st-checkbox__input" type="checkbox" id="checkbox0" name="checkbox0">
	                        <label for="checkbox0" class="st-checkbox__label"></label>
	                    </div>

	                    <div class="st-checkbox st-checkbox--disabled">
	                        <input disabled class="st-checkbox__input" type="checkbox" id="checkbox1" name="checkbox1">
	                        <label for="checkbox1" class="st-checkbox__label"></label>
	                    </div>

	                    <div class="st-checkbox st-checkbox--hover">
	                        <input checked="" class="st-checkbox__input" type="checkbox" id="checkbox2" name="checkbox2">
	                        <label for="checkbox2" class="st-checkbox__label"></label>
	                    </div>
	                </div>
	            </div>
	            <div class="dive"></div>
	            <div class="row col-xs-12 col-sm-6">
	                <h3 class="st-headline st-headline--3">Radios</h3>
	                <div>

	                    <div class="st-checkbox st-checkbox--radio">
	                        <input class="st-checkbox__input" type="radio" id="radio0" name="companion2">
	                        <label for="radio0" class="st-checkbox__label"></label>
	                    </div>

	                    <div class="st-checkbox st-checkbox--radio st-checkbox--disabled">
	                        <input disabled class="st-checkbox__input" type="radio" id="radio1" name="companion2">
	                        <label for="radio1" class="st-checkbox__label"></label>
	                    </div>

	                    <div class="st-checkbox st-checkbox--radio st-checkbox--hover">
	                        <input checked="" class="st-checkbox__input" type="radio" id="radio2" name="companion2">
	                        <label for="radio2" class="st-checkbox__label"></label>
	                    </div>

	                </div>
	            </div>
	        </div>
	    </div>
	    <!-- /checkbox -->

	    <!-- notice -->
	    <div class="st-group">
	        <div class="container container-max">
	            <h2 class="st-headline st-headline--2">Notice</h2>

	            <div class="dive"></div>
	            <h3 class="st-headline st-headline--3">Normal</h3>
	            <div class="row">
	                <div class="col-xs-12 col-sm-8">
	                    <div class="st-notice box-shadow">
	                        <div class="user-content-wrapper">
	                            Beim Absenden dieses Formulars wird eine automatische E-Mail<br>
	                            mit Login-Informationen an die angegebene Adresse verschickt.
	                        </div>
	                    </div>
	                    <div class="dive"></div>
	                    <div class="st-notice">
	                        <div class="user-content-wrapper">
	                            Beim Absenden dieses Formulars wird eine automatische E-Mail<br>
	                            mit Login-Informationen an die angegebene Adresse verschickt.
	                        </div>
	                    </div>
	                    <div class="dive"></div>
	                    <div class="st-notice st-notice--small">
	                        <div class="user-content-wrapper">
	                            Beim Absenden dieses Formulars wird eine automatische E-Mail<br>
	                            mit Login-Informationen an die angegebene Adresse verschickt.
	                        </div>
	                    </div>
	                    <div class="dive"></div>
	                    <div class="st-notice">
	                        <div class="row">
	                            <div class="col-xs-12 col-sm-1">
	                                <i class="fa fa-hand-o-right" aria-hidden="true"></i>
	                            </div>
	                            <div class="col-xs-12 col-sm-11">
	                                <div class="user-content-wrapper">
	                                    Beim Absenden dieses Formulars wird eine automatische E-Mail<br>
	                                mit Login-Informationen an die angegebene Adresse verschickt.
	                                </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </div>
	            <div class="dive"></div>
	            <h3 class="st-headline st-headline--3">Warning</h3>
	            <div class="row">
	                <div class="col-xs-12 col-sm-8">
	                    <div class="st-notice st-notice--warning">
	                        <div class="user-content-wrapper">
	                            Beim Absenden dieses Formulars wird eine automatische E-Mail<br>
	                            mit Login-Informationen an die angegebene Adresse verschickt.
	                        </div>
	                    </div>
	                    <div class="dive"></div>
	                    <div class="st-notice st-notice--small st-notice--warning">
	                        <div class="user-content-wrapper">
	                            Beim Absenden dieses Formulars wird eine automatische E-Mail<br>
	                            mit Login-Informationen an die angegebene Adresse verschickt.
	                        </div>
	                    </div>
	                    <div class="dive"></div>
	                    <div class="st-notice st-notice--warning">
	                        <div class="row">
	                            <div class="col-xs-12 col-sm-1">
	                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
	                            </div>
	                            <div class="col-xs-12 col-sm-11">
	                                <div class="user-content-wrapper">
	                                    Beim Absenden dieses Formulars wird eine automatische E-Mail<br>
	                                mit Login-Informationen an die angegebene Adresse verschickt.
	                                </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </div>
	            <div class="dive"></div>
	            <h3 class="st-headline st-headline--3">Error</h3>
	            <div class="row">
	                <div class="col-xs-12 col-sm-8">
	                    <div class="st-notice st-notice--error">
	                        <div class="user-content-wrapper">
	                            Beim Absenden dieses Formulars wird eine automatische E-Mail<br>
	                            mit Login-Informationen an die angegebene Adresse verschickt.
	                        </div>
	                    </div>
	                    <div class="dive"></div>
	                    <div class="st-notice st-notice--small st-notice--error">
	                        <div class="user-content-wrapper">
	                            Beim Absenden dieses Formulars wird eine automatische E-Mail<br>
	                            mit Login-Informationen an die angegebene Adresse verschickt.
	                        </div>
	                    </div>
	                    <div class="dive"></div>
	                    <div class="st-notice st-notice--error">
	                        <div class="row">
	                            <div class="col-xs-12 col-sm-1">
	                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
	                            </div>
	                            <div class="col-xs-12 col-sm-11">
	                                <div class="user-content-wrapper">
	                                    Beim Absenden dieses Formulars wird eine automatische E-Mail<br>
	                                mit Login-Informationen an die angegebene Adresse verschickt.
	                                </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </div>
	            <div class="dive"></div>
	            <h3 class="st-headline st-headline--3">Success</h3>
	            <div class="row">
	                <div class="col-xs-12 col-sm-8">
	                    <div class="st-notice st-notice--success">
	                        <div class="user-content-wrapper">
	                            Beim Absenden dieses Formulars wird eine automatische E-Mail<br>
	                            mit Login-Informationen an die angegebene Adresse verschickt.
	                        </div>
	                    </div>
	                    <div class="dive"></div>
	                    <div class="st-notice st-notice--small st-notice--success">
	                        <div class="user-content-wrapper">
	                            Beim Absenden dieses Formulars wird eine automatische E-Mail<br>
	                            mit Login-Informationen an die angegebene Adresse verschickt.
	                        </div>
	                    </div>
	                    <div class="dive"></div>
	                    <div class="st-notice st-notice--success">
	                        <div class="row">
	                            <div class="col-xs-12 col-sm-1">
	                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
	                            </div>
	                            <div class="col-xs-12 col-sm-11">
	                                <div class="user-content-wrapper">
	                                    Beim Absenden dieses Formulars wird eine automatische E-Mail<br>
	                                mit Login-Informationen an die angegebene Adresse verschickt.
	                                </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </div>
	        </div>
	    </div>
	    <!-- /notice -->

	    <!-- breadcrumb -->
	    <div class="st-group">
	        <div class="container container-max">
	            <h2 class="st-headline st-headline--2">Breadcrumb</h2>
	            <div class="dive"></div>
	            <div class="row">
	                <div class="col-xs-12">
	                    <ul class="st-breadcrumb" itemscope itemtype="http://schema.org/BreadcrumbList">
	                        <li class="st-breadcrumb__item" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
	                            <a class="st-breadcrumb__link" itemprop="item" href=""><span itemprop="name">Home</span></a>
	                        </li>
	                        <li class="st-breadcrumb__item" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
	                            <a class="st-breadcrumb__link" itemprop="item" href=""><span itemprop="name">Indirect Sales</span></a>
	                        </li>
	                        <li class="st-breadcrumb__item" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
	                            <a class="st-breadcrumb__link" itemprop="item" href=""><span itemprop="name">Teamleiter hinzufügen</span></a>
	                        </li>
	                    </ul>
	                </div>
	            </div>
	            <div class="dive"></div>
	            <h3 class="st-headline st-headline--3">Inline Nav</h3>
	            <div class="row">
	                <div class="col-xs-12">
	                    <a class="inline-nav" href="#">zurück zu allen Präsentationen</a>
	                </div>
	            </div>
	        </div>
	    </div>
	    <!-- /breadcrumb -->



	    <!-- table -->
	    <div class="st-group">
	        <div class="container container-max">
	            <h2 class="st-headline st-headline--2">Table (not sortable)</h2>
	            <div class="dive"></div>
	            <div class="row">
	                <div class="col-xs-12">
	                    <table class="st-table st-table--fixed st-table--full">
	                        <thead>
	                            <tr>
	                                <th>Title</th>
	                                <th>Title</th>
	                            </tr>
	                        </thead>
	                        <tbody>
	                            <tr class="has-action">
	                                <th>
	                                    <a class="st-table__link" href="#">Table Text Primary</a>
	                                    <div class="st-table-action">
	                                        <a class="st-table-action__link" href="#Bearbeiten">Bearbeiten</a> | <a  class="st-table-action__link st-table-action__link--delete" href="#Löschen">Löschen</a>
	                                    </div>
	                                </th>
	                                <td>Table Text</td>
	                            </tr>
	                            <tr>
	                                <th><a class="st-table__link" href="#">Table Text Primary</a></th>
	                                <td>Table Text</td>
	                            </tr>
	                            <tr>
	                                <th><a class="st-table__link" href="#">Table Text Primary</a></th>
	                                <td>Table Text</td>
	                            </tr>
	                        </tbody>
	                    </table>
	                </div>
	            </div>
	        </div>
	    </div>
	    <!-- /table -->

	    <!-- filters -->
	    <div class="st-group">
	        <div class="container container-max">
	            <h2 class="st-headline st-headline--2">Filters</h2>
	            <div class="dive"></div>
	            <div class="row">
	                <div class="col-xs-12">
	                    <div class="st-filters">
	                        <a href="#" class="st-filters__link st-filters__link--active">Alle (24)</a> |
	                        <a href="#" class="st-filters__link">Partner Business (12)</a> |
	                        <a href="#" class="st-filters__link">Project Business (12)</a>
	                    </div>
	                </div>
	            </div>
	        </div>
	    </div>
	    <!-- /filters -->

	    <!-- select -->
	    <div class="st-group">
	        <div class="container container-max">
	            <h2 class="st-headline st-headline--2">Select</h2>
	            <div class="dive"></div>
	            <div class="row">
	                <div class="col-xs-12">
	                    <select name="asd" id="asd" class="st-select">
	                        <option value="asd">asd</option>
	                        <option value="asd">asd</option>
	                        <option disabled="" value="asd">asd</option>
	                        <option value="asd">asd</option>
	                    </select>
	                    <select disabled="true" name="asd" id="asd" class="st-select">
	                        <option value="asd">asd</option>
	                        <option value="asd">asd</option>
	                        <option disabled="" value="asd">asd</option>
	                        <option value="asd">asd</option>
	                    </select>
	                </div>
	            </div>
	        </div>
	    </div>
	    <!-- /select -->


	    <!-- list -->
	    <div class="st-group">
	        <div class="container container-max">
	            <h2 class="st-headline st-headline--2">List</h2>
	            <div class="dive"></div>
	            <div class="row">
	                <div class="col-xs-12">
	                    <ul class="st-list">
	                        <li class="st-list__item">Lorem ipsum dolor sit amet</li>
	                        <li class="st-list__item">Lorem ipsum dolor sit amet</li>
	                        <li class="st-list__item">Lorem ipsum dolor sit amet</li>
	                    </ul>

	                    <ul class="st-list st-list--flat">
	                        <li class="st-list__item">Lorem ipsum dolor sit amet</li>
	                        <li class="st-list__item">Lorem ipsum dolor sit amet</li>
	                        <li class="st-list__item">Lorem ipsum dolor sit amet</li>
	                    </ul>
	                </div>
	            </div>
	        </div>
	    </div>
	    <!-- /list -->
	</div>
</template>

<script>
export default {
	name: 'p-styleguide'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/p-styleguide.vue